import { useRef, useCallback } from 'react';
/**
 * Wraps a function, causing it to ignore repeated calls.
 * The function will be executed after the delay period has passed with no further calls.
 * @param {Function} callback - Function to execute
 * @param {Number} delay - (in milliseconds)
 * @returns A function that executes the callback after the delay using the provided args
 */
const useDebounced = (callback, delay) => {
  const timeoutRef = useRef(null);
  return useCallback((...args) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      callback(...args);
    }, delay);
  }, [callback, delay]);
};

export default useDebounced;
